import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/motion";
import { getBlogs, px } from "../lib/api";

export default function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    getBlogs().then((d) => setBlogs(d.blogs));
  }, []);

  const [feature, ...rest] = blogs;

  return (
    <div data-testid="blog-page" className="pb-32">
      <PageHero
        testid="blog-hero"
        eyebrow="Notes from the kitchen"
        title="The"
        accent="Journal"
        subtitle="Recipes, rituals and the occasional rant about doing food the right way."
      />

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-14">
        {feature && (
          <Reveal>
            <Link
              to={`/blog/${feature.slug}`}
              data-testid={`blog-feature-${feature.slug}`}
              className="group grid lg:grid-cols-2 gap-8 rounded-lg overflow-hidden border border-border hover:border-orange transition-colors mb-14"
            >
              <div className="aspect-[16/10] lg:aspect-auto overflow-hidden">
                <img src={px(feature.image, 1000)} alt={feature.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-7 lg:p-10 flex flex-col justify-center">
                <span className="text-orange font-bold uppercase text-sm tracking-widest">{feature.category} · {feature.read}</span>
                <h2 className="font-heading uppercase text-4xl sm:text-5xl tracking-tighter leading-none mt-4">{feature.title}</h2>
                <p className="text-cream/70 text-lg mt-4">{feature.excerpt}</p>
                <span className="flex items-center gap-2 mt-6 text-cream font-bold uppercase text-sm group-hover:text-orange transition-colors">
                  Read Article <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          </Reveal>
        )}

        <div className="grid md:grid-cols-3 gap-6">
          {rest.map((b, i) => (
            <Reveal key={b.id} delay={i * 0.08}>
              <Link
                to={`/blog/${b.slug}`}
                data-testid={`blog-card-${b.slug}`}
                className="group block h-full bg-card border border-border rounded-lg overflow-hidden hover:border-orange transition-colors"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={px(b.image, 700)} alt={b.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-5">
                  <span className="text-orange font-bold uppercase text-xs tracking-widest">{b.category} · {b.read}</span>
                  <h3 className="font-heading uppercase text-2xl tracking-tight mt-2 leading-tight">{b.title}</h3>
                  <p className="text-cream/60 text-sm mt-2">{b.excerpt}</p>
                  <p className="text-cream/40 text-xs mt-4">{b.date}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
